export default "__VITE_ASSET__6LW24EzY__"